import React from 'react';
import styled from 'styled-components';
import { ApiStore, Subscribe } from 'Store';

import { toHumanReadable } from 'Libs/date';

import { Container, Header } from 'Components/core';
import { colors, layout } from 'Constants';
import AppleIcon from 'Icons/apple-alt.svg';
import StethoscopeIcon from 'Icons/stethoscope-alt.svg';
import HeartIcon from 'Icons/heart-alt.svg';
import PillsIcon from 'Icons/pills-alt.svg';

const InfoButtonPanel = styled.div`
  display: flex;

  width: 400px;
  padding-right: 64px;
  position: relative;
  justify-content: space-around;
`;

const Icon = styled.img`
  cursor: pointer;
  margin-bottom: -20px;
  height: 60px;
  width: 60px;
`;

const InfoContainer = styled(Container)`
  margin: 32px;
  max-width: 400px;
  width: 100%;

  > div {
    padding: 32px;
    padding-bottom: 30px;
    margin-bottom: 32px;
    background-color: #fff;
    z-index: 2;

    > * {
      margin: 0;
    }

    > * + * {
      margin-top: 16px;
    }
  }

  position: relative;
  ::after,
  ::before {
    content: '';
    position: absolute;
    left: -24px;
    right: -24px;
    background-color: ${colors.accent};
    height: 100%;
    
  }

  ::after {
    top: -24px;
  }

  ::before {
    
  }
`;

export default () => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <InfoContainer column>
        <div>
          <Header>Choosing and using your plan</Header>
          <p style={{ fontSize: '0.9em' }}>
            Now is the perfect time to think about your health — where you are
            right now and where you want to be tomorrow. Take time to explore
            the benefits, programs and resources that can support your health
            and well-being all year long.
          </p>
         {isNaN(state?.oeMaterials?.oeStart)==false && state?.oeMaterials?.oeStart!=null && <p>
            <strong>
              Open enrollment runs from{' '}
              {toHumanReadable(state?.oeMaterials?.oeStart)} {isNaN(state?.oeMaterials?.oeEnd)==false?" to ":""}
              {toHumanReadable(state?.oeMaterials?.oeEnd)}
            </strong>{' '}
          </p>}

          {false && <InfoButtonPanel>
            <Icon
              alt="Stethoscope"
              src={StethoscopeIcon}
              style={{ cursor: 'default' }}
            />
            <Icon alt="Pills" src={PillsIcon} style={{ cursor: 'default' }} />
            <Icon alt="Heart" src={HeartIcon} style={{ cursor: 'default' }} />
            <Icon alt="Apple" src={AppleIcon} style={{ cursor: 'default' }} />
          </InfoButtonPanel>}
        </div>
      </InfoContainer>
    )}
  </Subscribe>
);
